import { Component } from '@angular/core';

@Component({
  selector: 'howden-login-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class FailedComponent {
}
